import Colors from 'constants/Colors';

export default {
  labelTitle: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#424242',
  },
  descriptionText: {
    margin: 0,
    fontSize: '12px',
    color: '#888',
  },
  iconModal: {
    margin: '25px 0px',
    backgroundColor: Colors.blueIconBg,
    color: Colors.blueIcon,
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconModalDelete: {
    margin: '25px 0px',
    backgroundColor: Colors.redDesactivedBg,
    color: Colors.red,
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleModal: {
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '8px',
  },
  textModal: {
    fontSize: '13px',
    color: '#333',
    textAlign: 'center',
    marginBottom: '20px',
  },
  modalButton: {
    display: 'flex',
    justifyContent: 'center',
  },
  editIcon: {
    backgroundColor: Colors.blueIconBg,
    color: Colors.blueColor,
    borderColor: Colors.lightBlue,
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '8px',
  },
  editTitle: {
    fontSize: '18px',
  },
  editDescription: {
    fontSize: '12px',
    color: Colors.grayText,
    marginBottom: '16px',
  },
  textContainerModal: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  unblockButton: {
    width: '95%',
    borderRadius: '5px',
    backgroundColor: Colors.redDesactivedBg,
    borderColor: Colors.redDesactivedText,
    marginBottom: '10px',
  },
  editButton: {
    width: '95%',
    borderRadius: '5px',
    backgroundColor: Colors.blueColor,
    borderColor: Colors.blueColor,
    marginBottom: '10px',
  },
  deleteButton: {
    width: '95%',
    borderRadius: '5px',
    backgroundColor: Colors.blueColor,
    borderColor: Colors.blueColor,
    marginBottom: '10px',
  },
  cancelButton: {
    width: '95%',
    borderRadius: '5px',
  },
};
